import React from "react";
import { array, bool } from "prop-types";

import CustomStoryCard2 from "../../../molecules/CustomStoryCard2";

import "./organism1.m.css";

const Organism1 = ({ stories, updatedFont }) => {
  return (
    <div styleName="wrapper">
      {stories.splice(0, 1).map((story, index) => (
        <CustomStoryCard2
          story={story.story}
          key={index}
          headlineType={3}
          subHeadlineType={6}
          isImageCaptionRequired={false}
          isSection={false}
          className="first-story"
          widths={[500]}
          isExcerpt={true}
          updatedFont={updatedFont}
          src="six-story-with-poll"
          updateSubHeadline={true}
        />
      ))}
      {stories.map((story, index) => (
        <CustomStoryCard2
          story={story.story}
          key={index}
          headlineType={4}
          subHeadlineType={6}
          isImageCaptionRequired={false}
          isSection={false}
          className="second-story"
          widths={global.deviceWidth < 876 ? [120] : [200]}
          isExcerpt={true}
          updatedFont={updatedFont}
          isSmallCard={true}
          src="six-story-with-poll"
          updateSubHeadline={true}
        />
      ))}
    </div>
  );
};

Organism1.propTypes = {
  stories: array.isRequired,
  updatedFont: bool
};

export default Organism1;
